import React from 'react';

const BUTTON_STATES = {
  READY: 'ready',
  SUBMITTING: 'submitting',
  SUCCESS: 'success'
};

const SubmitButton = ({
  buttonState,
  onClick,
  buttonClassName = '',
  spinnerSrc = 'https://d2atdwxjx7uc4i.cloudfront.net/images/bx_loader.gif'
}) => {
  const isDisabled = buttonState !== BUTTON_STATES.READY;

  const getButtonContent = () => {
    switch (buttonState) {
      case BUTTON_STATES.SUBMITTING:
        return (
          <>
            <img
              src={spinnerSrc}
              width="16"
              alt=""
              aria-hidden="true"
              style={{ verticalAlign: 'middle', marginRight: '8px' }}
            />
            {t('quote_builder_widget.submit')}
          </>
        );
      case BUTTON_STATES.SUCCESS:
        return t('quote_builder_widget.thank_you');
      default:
        return t('quote_builder_widget.submit');
    }
  };

  return (
    <button
      type="button"
      className={buttonClassName}
      onClick={onClick}
      disabled={isDisabled}
      data-widget-element="submit-button"
      aria-busy={buttonState === BUTTON_STATES.SUBMITTING}
    >
      {getButtonContent()}
    </button>
  );
};

export default SubmitButton;
